import React from 'react';

const C = { navy: '#0D1B2A', blue: '#1A4C7C', red: '#E24B4A', slate: '#5C6B7A' };
const cls = 'text-xs border rounded-sm px-2 py-1.5 bg-white w-full';

export function Field({ label, path, value, onChange, errors, placeholder, type = 'text', required, hint, children }) {
  const err = errors?.[path];
  const id = `brokerage-${path.replace(/\./g, '-')}`;
  return (
    <label className="block" data-testid={`${id}-field`}>
      <span className="text-[10px] uppercase tracking-wider" style={{ color: C.slate }}>{label}{required && <span style={{ color: C.red }}> *</span>}</span>
      {children || (
        <input id={id} type={type} value={value ?? ''} onChange={e => onChange(path, e.target.value)} placeholder={placeholder}
          className={cls} style={{ borderColor: err ? C.red : 'rgba(136,150,168,0.4)', color: C.navy }} data-testid={id} />
      )}
      {err ? <span className="text-[10px]" style={{ color: C.red }} data-testid={`${id}-error`}>{err}</span>
           : hint && <span className="text-[10px]" style={{ color: C.slate }}>{hint}</span>}
    </label>
  );
}

export function Select({ path, value, onChange, options, errors }) {
  const err = errors?.[path];
  const id = `brokerage-${path.replace(/\./g, '-')}`;
  return (
    <select id={id} value={value ?? ''} onChange={e => onChange(path, e.target.value)} className={cls}
      style={{ borderColor: err ? C.red : 'rgba(136,150,168,0.4)', color: C.navy }} data-testid={id}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export default function BrokerageProfileForm({ form, setField, errors, meta }) {
  const lic = form.licence || {};
  const c = form.contact || {};
  const a = c.address || {};
  const isCar = lic.type === 'car';
  return (
    <div className="space-y-5" data-testid="brokerage-profile-form">
      <section className="grid md:grid-cols-2 gap-3">
        <Field label="ABN" path="abn" value={form.abn} onChange={setField} errors={errors} required placeholder="51 824 753 556"
          hint="Eleven digits — checked against the ATO checksum and confirmed on the ABR when a key is configured" />
        <Field label="Licence" path="licence.type" errors={errors}>
          <Select path="licence.type" value={lic.type || 'afsl'} onChange={setField} errors={errors}
            options={Object.entries(meta.licence_types || {}).map(([k, v]) => [k, v])} />
        </Field>
        <Field label={isCar ? 'Authorised Representative number' : 'AFSL number'} path="licence.number" value={lic.number} onChange={setField} errors={errors} required
          placeholder={isCar ? '1234567' : '238 123'} hint={isCar ? 'Your CAR number as it appears on the ASIC register' : 'As it appears on the ASIC register'} />
        {isCar && <Field label="Licensee" path="licence.licensee" value={lic.licensee} onChange={setField} errors={errors} required placeholder="The AFS licensee you represent" />}
        {isCar && <Field label="Licensee's AFSL" path="licence.licensee_afsl" value={lic.licensee_afsl} onChange={setField} errors={errors} placeholder="238 123" />}
      </section>
      <section>
        <h3 className="text-[11px] font-semibold uppercase tracking-wider mb-2" style={{ color: C.blue }}>Contact</h3>
        <div className="grid md:grid-cols-2 gap-3">
          <Field label="Principal contact" path="contact.principal_name" value={c.principal_name} onChange={setField} errors={errors} placeholder="Name of the responsible manager" />
          <Field label="Phone" path="contact.phone" value={c.phone} onChange={setField} errors={errors} required placeholder="03 5331 0000" />
          <Field label="E-mail" path="contact.email" value={c.email} onChange={setField} errors={errors} required placeholder="office@yourbrokerage.com.au" type="email" />
          <Field label="Website" path="contact.website" value={c.website} onChange={setField} errors={errors} placeholder="www.yourbrokerage.com.au" />
        </div>
      </section>
      <section>
        <h3 className="text-[11px] font-semibold uppercase tracking-wider mb-2" style={{ color: C.blue }}>Office address</h3>
        <div className="grid md:grid-cols-4 gap-3">
          <div className="md:col-span-2"><Field label="Street" path="contact.address.street" value={a.street} onChange={setField} errors={errors} required placeholder="12 Lydiard Street North" /></div>
          <Field label="Suburb" path="contact.address.suburb" value={a.suburb} onChange={setField} errors={errors} required placeholder="Ballarat Central" />
          <div className="grid grid-cols-2 gap-2">
            <Field label="State" path="contact.address.state" errors={errors} required>
              <Select path="contact.address.state" value={a.state || ''} onChange={setField} errors={errors}
                options={[['', '—'], ...(meta.states || []).map(s => [s, s])]} />
            </Field>
            <Field label="Postcode" path="contact.address.postcode" value={a.postcode} onChange={setField} errors={errors} required placeholder="3350" />
          </div>
        </div>
      </section>
    </div>
  );
}
